const noteIcons = state => noteTypeId => {
  return state.note_icons.find(li => li.id === noteTypeId).icon;
};
const state = state => stateId => {
  return state.state.find(s => s.id === stateId);
};

const globalClient = state => state.globalClient;

const globalContractor = state => state.globalContractor;

export default {
  globalClient,
  globalContractor,
  noteIcons,
  state
};
